import { render, staticRenderFns } from "./TheSavedWorkflowReport.vue?vue&type=template&id=33321038&scoped=true&"
import script from "./TheSavedWorkflowReport.vue?vue&type=script&lang=js&"
export * from "./TheSavedWorkflowReport.vue?vue&type=script&lang=js&"
import style0 from "./TheSavedWorkflowReport.vue?vue&type=style&index=0&id=33321038&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33321038",
  null
  
)

export default component.exports